export default "__VITE_ASSET__DIXRfuhN__"